import { Box, Center, Icon, Text } from '@chakra-ui/react'
import { SadFace } from '../utils/constants/icons'
import useWindowHeight from '../hooks/useWindowHeight'

const InvalidDisplaySize = () => {
  const windowHeight = useWindowHeight()

  return (
    <Center w="100vw" h={`${windowHeight}px`} bg="secondary.400">
      <Box
        pos="absolute"
        top="50px"
        bgImage="/logo/white-md.svg"
        w="100px"
        h="40px"
        bgPos="center"
        bgSize="contain"
        bgRepeat="no-repeat"
      />

      <Box maxW="330px">
        <Center mb="26px">
          <Icon width="47px" height="48px" viewBox="0 0 47 48">
            <SadFace />
          </Icon>
        </Center>

        <Text mb="10px" color="white" textStyle="h5" textAlign="center">
          Ocean is not supported on this screen size
        </Text>

        <Text color="white" textStyle="b-sm" textAlign="center" fontWeight="400">
          Ocean can only be accessed with desktop devices, open it with your desktop device and start exploring the
          ocean!
        </Text>
      </Box>
    </Center>
  )
}

export default InvalidDisplaySize
